import { Spinner } from "@heroui/react";
import React from "react";

import { useTeam } from "@wc/domain/teams";
import TeamInfo from "@wc/domain/teams/components/team-info";
import usePageTitle from "@wc/ui/hooks/page-title";

/**
 * @returns {React.ReactElement} View and edit team information
 */
export default function TeamInfoPage() {
  const teamData = useTeam();

  usePageTitle(teamData.team?.name || "");

  if (!teamData.team) {
    return (
      <div className="mt-8 flex justify-center">
        <Spinner color="primary" />
      </div>
    );
  }

  return (
    <div className="m-5">
      <TeamInfo readOnly={false} />
    </div>
  );
}
